import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'react-i18next';

import DigitalCnyGuideImg from '@/assets/digital-cny-guide.png';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogFooter } from '@/components/ui/dialog';

const ECNYTutorialModal = NiceModal.create(() => {
  const modal = useModal('ecny-tutorial-modal');

  const handleClose = () => {
    modal.hide();
    setTimeout(() => {
      modal.remove();
    }, 100);
  };

  const { t } = useTranslation();

  return (
    <Dialog open={modal.visible}>
      <DialogContent className="w-[90%] max-w-[320px]">
        <div className="max-h-[430px] overflow-y-scroll">
          <img src={DigitalCnyGuideImg} alt="digital cny guide" />
        </div>
        <DialogFooter className="flex justify-between">
          <Button className="flex-1" onClick={handleClose}>
            {t('acknowledge')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});

export default ECNYTutorialModal;
